import React from 'react';
import styles from './Pod.module.css';
import { useDocument } from '../../context/documentInfoContex';
import UndoRedoButtons from './UndoRedoButtons';
import ZoomButtons from './ZoomButtons';

/** The strip under the dock: undo / redo (editors only), then zoom. */
const SidePod = () => {
    const { isReadOnly } = useDocument();
    return (
        <div className={styles.pod}>
            {!isReadOnly && (
                <>
                    <UndoRedoButtons shortcuts />
                    <span className={styles.divider} aria-hidden="true" />
                </>
            )}
            <ZoomButtons />
        </div>
    );
};

export default SidePod;
